"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keysToLowerCase = exports.keysToCamel = exports.getFirstOrDefault = exports.getEnumValues = exports.removeByIndex = exports.removePrefix = exports.removePostfix = exports.cloneArray = exports.sortAlphabetically = exports.sortByKey = exports.getStringCompareFunction = exports.fromObjectToArray = exports.fromArrayToObject = void 0;
exports.safe = safe;
exports.findIndex = findIndex;
function safe(list, empty = []) {
    return Array.isArray(list) ? list : empty;
}
const String_utils_1 = require("./String.utils");
function findIndex(arr, cb) {
    if (!arr || arr.length === 0) {
        return -1;
    }
    let i = 0;
    const len = arr.length;
    while (i < len) {
        if (cb(arr[i], i)) {
            return i;
        }
        i++;
    }
    return -1;
}
const fromArrayToObject = (array, keyField) => {
    return safe(array).reduce((obj, item) => {
        if (item) {
            obj[item[keyField]] = item;
        }
        return obj;
    }, {});
};
exports.fromArrayToObject = fromArrayToObject;
const fromObjectToArray = (object) => Object.keys(object).map(k => object[k]);
exports.fromObjectToArray = fromObjectToArray;
const getStringCompareFunction = (key, ignoreCase = false) => {
    return (a, b) => {
        return (0, String_utils_1.compareString)(a[key], b[key], ignoreCase);
    };
};
exports.getStringCompareFunction = getStringCompareFunction;
const sortByKey = (array, key, ignoreCase = false) => {
    return array.sort((0, exports.getStringCompareFunction)(key, ignoreCase));
};
exports.sortByKey = sortByKey;
const sortAlphabetically = (arrayOfStrings, ignoreCase = true) => {
    return arrayOfStrings.sort((a, b) => {
        return (0, String_utils_1.compareString)(a, b, ignoreCase);
    });
};
exports.sortAlphabetically = sortAlphabetically;
const cloneArray = (array) => {
    return array.map(a => (Object.assign({}, a)));
};
exports.cloneArray = cloneArray;
const removePostfix = (source, postfix) => {
    let result = source;
    if (result && postfix && result.substr(-postfix.length) === postfix) {
        result = result.substr(0, result.length - postfix.length);
    }
    return result;
};
exports.removePostfix = removePostfix;
const removePrefix = (source, prefix) => {
    let result = source;
    if (result && prefix && result.indexOf(prefix, 0) === 0) {
        result = result.substr(prefix.length);
    }
    return result;
};
exports.removePrefix = removePrefix;
const removeByIndex = (source, index) => {
    if (index !== -1) {
        const clone = source.slice(0);
        clone.splice(index, 1);
        return clone;
    }
    return source;
};
exports.removeByIndex = removeByIndex;
const getEnumValues = (source) => {
    const names = Object.keys(source).filter(key => isNaN(+key));
    return names.map(name => source[name]);
};
exports.getEnumValues = getEnumValues;
const getFirstOrDefault = (source, defaultValue, cb = null) => {
    if (!source || source.length < 1) {
        return defaultValue;
    }
    if (cb) {
        source = source.filter(cb);
    }
    return source.length > 0 ? source[0] : defaultValue;
};
exports.getFirstOrDefault = getFirstOrDefault;
const isObject = o => {
    return o === Object(o) && !Array.isArray(o) && typeof o !== 'function';
};
const toCamel = s => {
    return s.replace(/([-_][a-z])/gi, $1 => {
        return $1.toUpperCase().replace('-', '').replace('_', '');
    });
};
const keysToCamel = o => {
    if (isObject(o)) {
        const n = {};
        Object.keys(o).forEach(k => {
            const key = (0, String_utils_1.lowerFirstLetter)(k);
            n[toCamel(key)] = (0, exports.keysToCamel)(o[k]);
        });
        return n;
    }
    else if (Array.isArray(o)) {
        return o.map(i => {
            return (0, exports.keysToCamel)(i);
        });
    }
    return o;
};
exports.keysToCamel = keysToCamel;
const keysToLowerCase = (originalObject) => {
    if (!isObject(originalObject))
        return originalObject;
    return Object.keys(originalObject).reduce((acc, currKey) => {
        acc[currKey.toLowerCase()] = originalObject[currKey];
        return acc;
    }, {});
};
exports.keysToLowerCase = keysToLowerCase;
